import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import RecentSleevesContainer from "../../Components/Containers/RecentSleevesContainer";
import "./home.less";
import SleeveResult from "../../Components/SleeveResult";
import SleeveMini from "~/Components/SleeveMini";
import RecentCommentsContainer from "~/Components/Containers/RecentCommentsContainer";

//testing

const HomePage = () => {
  return (
    <div className="page-home">
      <Helmet>
        <title>Sleevery | Dream Chimney</title>
      </Helmet>
      <Row>
        <Col xs={12}>
          <p className="intro">
            Welcome to Dream Chimney's Sleevery, where we have archived the oddest, wildest and simply the best record covers ever made.
          </p>
        </Col>
      </Row>
      <RecentSleevesContainer
        render={({ sleeves, loading }) => {
          if (loading) return `Loading...`;
          const [firstSleeve, ...restSleeves] = sleeves;
          return (
            <React.Fragment>
              <Row>
                <Col xs={12}>
                  <div className="most-recent">
                    <h3>Most Recent</h3>

                    <SleeveResult sleeve={firstSleeve} featured />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <div className="recent">
                    <h3>Recent Sleeves</h3>
                    <ul className="results cover-wall">
                      {restSleeves.map((sleeve) => {
                        return (
                          <li key={sleeve.id}>
                            <SleeveMini sleeve={sleeve} />
                          </li>
                        );
                      })}
                    </ul>
                    {/* <ul>
                      <li ng-repeat="sleeve in recent" ng-if="$index > 0">
                        <sleeve-mini-result sleeve="sleeve"></sleeve-mini-result>
                      </li>
                    </ul> */}

                    <div className="next">
                      <i className="fa fa-arrow-circle-right"></i> <Link to="sleeves/list">Keep going</Link>, there are so many more.
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <div className="recent-comments comments-section">
                    <h3>Recent Comments</h3>

                    <RecentCommentsContainer
                      render={({ comments, loading }) => {
                        if (loading) return "loading...";
                        return comments.map(({ comment, sleeve }) => (
                          <div className="well" key={comment.id}>
                            <div className="sleeveMiniResult">
                              <div className="sleeve-cover">
                                <Link to={`/sleeves/view/${sleeve.id}`}>
                                  <img
                                    src={`https://res.cloudinary.com/dreamchimney/image/upload/w_220/sleevery/${sleeve.id}.jpg`}
                                    className="sleeve-mini center-block img-responsive"
                                  />
                                </Link>
                              </div>
                            </div>
                            <div className="comment">
                              <span className="author">
                                <strong>{comment.user}</strong>
                              </span>
                              <div className="message">{comment.message}</div>
                              <div className="date">({comment.date})</div>
                            </div>
                          </div>
                        ));
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          );
        }}
      />
    </div>
  );
};

export default HomePage;
